<template>
  <div :class="['shape-svg', filledClass]">
    <svg
      v-if="shape == 'email'"
      width="36"
      height="27"
      viewBox="0 0 36 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M34 13V19.6667C34 22.6122 31.6122 25 28.6667 25H7.33333C4.38782 25 2 22.6122 2 19.6667V13M7.33333 24H28.6667C31.6122 24 34 21.6122 34 18.6667V7.33333C34 4.38781 31.6122 2 28.6667 2H7.33333C4.38781 2 2 4.38781 2 7.33333V18.6667C2 21.6122 4.38782 24 7.33333 24Z"
          stroke="#807D79"
          class="colorable-stroke"
          stroke-width="1.81567"
        />
      </g>
      <g>
        <path
          d="M3 4.04225L12.071 13.1133M32.9443 3.5L23.3303 13.1133M23.3303 13.1133L21.8909 14.5526C19.5767 16.8669 15.8246 16.8669 13.5104 14.5527L12.071 13.1133M23.3303 13.1133L32.9443 22.7273M12.071 13.1133L3 22.1843"
          stroke="#807D79"
          class="colorable-stroke"
          stroke-width="1.81567"
        />
      </g>
    </svg>
    <svg
      width="44"
      height="43"
      viewBox="0 0 44 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      v-if="shape == 'circle'"
      :style="{ '--shape-color': '#2C81A3' }"
    >
      <!-- <g filter="url(#filter0_f_6002_11050)"> -->
      <g>
        <path
          d="M39.625 21.5C39.625 30.9016 31.7911 38.625 22 38.625C12.2089 38.625 4.375 30.9016 4.375 21.5C4.375 12.0984 12.2089 4.375 22 4.375C31.7911 4.375 39.625 12.0984 39.625 21.5Z"
          stroke="#2C81A3"
          stroke-width="4.75"
        />
      </g>
      <!-- <defs>
        <filter
          id="filter0_f_6002_11050"
          x="-1"
          y="-1"
          width="44"
          height="44"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.663462"
            result="effect1_foregroundBlur_6002_11050"
          />
        </filter>
      </defs> -->
    </svg>

    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :style="{ '--shape-color': '#399938' }"
      v-if="shape == 'rounner'"
    >
      <!-- <g filter="url(#filter0_f_6002_11047)"> -->
      <g>
        <path
          d="M32.8743 6.57236L32.877 6.57466C34.5952 8.01884 35.625 10.2651 35.625 13.6537V35.625H4.375V4.375H25.0554C28.8206 4.375 31.2556 5.20763 32.8743 6.57236Z"
          stroke="#399938"
          stroke-width="4.75"
        />
      </g>
      <!-- <defs>
        <filter
          id="filter0_f_6002_11047"
          x="-1"
          y="-1"
          width="41"
          height="41"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.742039"
            result="effect1_foregroundBlur_6002_11047"
          />
        </filter>
      </defs> -->
    </svg>

    <svg
      width="40"
      height="47"
      viewBox="0 0 40 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      :style="{ '--shape-color': '#E32C12' }"
      v-if="shape == 'hexagon'"
    >
      <!-- <g filter="url(#filter0_f_6002_11046)"> -->
      <g>
        <path
          d="M19.0777 3.9246C19.6466 3.58834 20.3534 3.58834 20.9223 3.9246L21.5265 2.90234L20.9223 3.9246L36.1088 12.9013C36.6606 13.2274 36.999 13.8207 36.999 14.4616V32.5384C36.999 33.1793 36.6605 33.7726 36.1088 34.0987L20.9223 43.0754C20.3534 43.4117 19.6466 43.4117 19.0777 43.0754L3.89118 34.0987C3.33945 33.7726 3.00097 33.1793 3.00097 32.5384V14.4616C3.00097 13.8207 3.33945 13.2274 3.89118 12.9013L19.0777 3.9246Z"
          stroke="#E32C12"
          stroke-width="4.75"
        />
      </g>
      <!-- <defs>
        <filter
          id="filter0_f_6002_11046"
          x="-1"
          y="-1"
          width="42"
          height="49"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.75"
            result="effect1_foregroundBlur_6002_11046"
          />
        </filter>
      </defs> -->
    </svg>

    <svg
      v-if="shape == 'triangle'"
      width="49"
      height="43"
      viewBox="0 0 49 43"
      fill="none"
      :style="{ '--shape-color': '#FEB018' }"
      xmlns="http://www.w3.org/2000/svg"
    >
      <!-- <g filter="url(#filter0_f_6002_11049)"> -->
      <g>
        <path
          d="M25.1197 3.39949L45.6189 38.905C45.9147 39.4174 45.5449 40.0579 44.9533 40.0579H3.955C3.36335 40.0579 2.99357 39.4174 3.2894 38.905L23.7885 3.39949C24.0843 2.88711 24.8239 2.8871 25.1197 3.39949Z"
          stroke="#FEB018"
          stroke-width="4.75"
        />
      </g>
      <!-- <defs>
        <filter
          id="filter0_f_6002_11049"
          x="-1"
          y="-1"
          width="50"
          height="49"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="0.75"
            result="effect1_foregroundBlur_6002_11049"
          />
        </filter>
      </defs> -->
    </svg>
  </div>
</template>

<script>
export default {
  name: "Shape",
  data() {
    return {};
  },
  props: ["shape", "filled"],
  computed: {
    shapeColor() {
      switch (this.shape) {
        case "triangle":
          return "var(--orange)";
        default:
          return "";
      }
    },
    filledClass() {
      return this.filled === true ? "shape--is-filled" : "";
    },
  },
  methods: {},
  mounted() {},
};
</script>

<style>
.shape-svg {
  height: 50%;
  width: 100%;
  display: flex;
  overflow: visible;
  filter: blur(1px);
}

.nav--is-expanded .shape-svg {
  filter: blur(1.7px);
}

.shape-svg svg {
  height: 100%;
  width: 100%;
  overflow: visible;
}

.shape-svg svg g path {
  transition: var(--motion-primary);
  fill: transparent;
}

.shape-svg.shape--is-filled svg g path {
  fill: var(--shape-color);
}
</style>

